import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
/**
 * Page additional fields
 */

ICmsContentService.registerPageMetaPatch(pageMeta => {
    pageMeta.fields?.push(
        {
            key: 'typeData.showBreadcrumb',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Show breadcrumb',
            default: false
        },
        {
            key: 'typeData.darkBreadcrumb',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Dark breadcrumb',
            default: false
        }
    );
});
